
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M208.3 250h83.3V145.8H375L252.1 0 125 145.8h83.3V250zm-37.5-125L252 31.3l77.1 93.7h-58.3v104.2h-41.7V125h-58.3zm162.5 229.2h83.3V375h-83.3zm-41.6 62.4h125v20.8h-125z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M458.3 458.3c0 12.5-8.3 20.8-20.8 20.8h-375c-12.5 0-20.8-8.3-20.8-20.8V229.2c0-2.1 0-4.2 2.1-6.3L250 368.7l206.2-145.8c0 2.1 2.1 4.2 2.1 6.3h20.8c0-22.9-18.8-41.7-41.7-41.7H333.3v20.8h106.3L250 341.7 60.4 208.3h106.3v-20.8H62.5c-22.9 0-41.7 18.8-41.7 41.7v229.2c0 22.9 18.8 41.7 41.7 41.7h375c22.9 0 41.7-18.8 41.7-41.7V354.2h-20.8l-.1 104.1z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M458.3 270.8h20.8v41.7h-20.8z"}})])
          )
        }
      }
    